// extracted by mini-css-extract-plugin
module.exports = {"content":"Tooltip_content__ozEWO","trigger":"Tooltip_trigger__iFJGO","contentWrapper":"Tooltip_contentWrapper__6d5b7","fallbackIcon":"Tooltip_fallbackIcon__5jlCD"};